// `send` — the base transaction's send button (`handler: "send"`) delivers its
// template for the saved record: the same queue and channels (IOFlow, or the
// email fallback) a person's send uses. The browser names only the step and
// the record (`wizard_send`); the button, template and recipients are the
// model's. Once queued it cannot be taken back, so Back does not cross it.

import { CheckCircle2, Send } from 'lucide-react'
import { text } from '../model'
import { GOOD, banner, button, muted } from '../styles'
import { tw } from '../../testHooks'
import type { StepProps } from './common'

export default function SendStep({ ctl, handheld }: StepProps) {
  const { step, scope, ui, busy } = ctl
  if (!step || !scope) return null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {step.help && <div style={muted}>{text(step.help, scope)}</div>}
      <button type="button" style={button(handheld, !ui.sent, !!busy || ui.sent)}
        disabled={!!busy || ui.sent} onClick={() => void ctl.send()} {...tw('action', 'send')}>
        <Send size={18} /> {ui.sent ? 'Sent' : 'Send'}
      </button>
      {ui.sent && <div style={banner(GOOD)}><CheckCircle2 size={16} /> On its way.</div>}
      {!ui.sent && step.required !== false && <div style={muted}>This is sent before you continue.</div>}
    </div>
  )
}
